// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__QmgUg","dragIcon":"SortableItem_dragIcon__3qt7G","disabled":"SortableItem_disabled__3-92O"};